import { ElementRef } from '@angular/core';

import { checkHasParentDomElement } from '@lvflanders/bar';

/** Ensures that a given element ref is in the footer widgets section. */
export function ensureInBaasFooterWidgetsSection(element: ElementRef): void {
    if (!checkHasParentDomElement(element.nativeElement, '#baas-layout-footer-widgets')) {
        throw Error('Element is not inside footer-widgets section of the layout.');
    }
}
